const formatHashedPhone = (phone: string): string => {
  const matched = phone.match(/.{1,3}/g);
  return matched !== null ? matched.join(' ') : '';
};

const isOtpDelay = (otpDelay: number): boolean => otpDelay > 0;

export { formatHashedPhone, isOtpDelay };
